import * as ng from 'angular';

export default (module: ng.IModule) => {
    module.component('tyPostComposer', {
        bindings: {},
        // language=HTML
        template: `<div class="ty-post-composer" is-uib>
    <div class="panel panel-elevated">
        <div class="panel-body">
            <ty-simplemde placeholder="What's on your mind?"></ty-simplemde>
        </div>
        <div class="panel-footer">
            <select name="" id="">
                <option value="">Public</option>
                <option value="">My community</option>
                <option value="">Only me</option>
            </select>
            <button class="btn btn-primary">Publish Post</button>
        </div>
    </div>
</div>
`,
        controller: PostComposerCtrl,
    });
};

// Needs to wit for it's day of glory after we refactor what we have at least a bit.
class PostComposerCtrl implements ng.IComponentController {
    static $inject = [];

    constructor() {}

    $onInit() {
        // nice
    }

    $onChanges(onChangesObj: ng.IOnChangesObject) {
        // on changes
    }

    $onDestroy() {
        // cleanup logic
    }
}
